<script lang="ts" setup>
  import { ElDivider } from 'element-plus';
  import { computed } from 'vue';
  import { excludeObjectKeys } from '../../../utils';
  import { DividerProps } from './divider';

  defineOptions({
    name: 'IDivider',
  });
  const props = defineProps(DividerProps);

  const attrs = computed(() => excludeObjectKeys(props, ['label']));
</script>

<template>
  <ElDivider v-bind="attrs">{{ label }}</ElDivider>
</template>

<style scoped></style>
